const Crifferent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
    <path
      style={{
        fill: "#2d2d2d",
      }}
      d="M0 0h500v500H0z"
    />
    <path
      d="M66.5 162 122 94m-55.5 68v79.5l75 16m-75-95.5 136.5-5.5M122 94l66.5-32.5M122 94l19.5 163.5m47-196H303m-114.5 0L322 162M303 61.5l87.5 40m-87.5-40-100 95m187.5-55 55.5 68m-55.5-68L322 162m124 7.5V264m0-94.5-148.5 80M446 264 322 162m124 102-80.5 67m80.5-67-148.5-14.5M322 162l-180.5 95.5m0 0L169 325l94 27m-121.5-94.5 224 73.5M263 352v-38m0 38v87.5m0-125.5-60-157.5M263 314l34.5-64.5m-94.5-93 94.5 93m68 81.5v108.5"
      style={{
        fill: "none",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
    <path
      style={{
        fill: "#f8f8f8",
      }}
      d="M49 55h12v12H49zM61 67h12v12H61zM61 43h12v12H61zM73 55h12v12H73zM427 83h12v12h-12zM439 95h12v12h-12zM439 71h12v12h-12zM451 83h12v12h-12zM387 365h12v12h-12zM399 377h12v12h-12zM399 353h12v12h-12zM411 365h12v12h-12zM116 379h12v12h-12zM128 391h12v12h-12zM128 367h12v12h-12zM140 379h12v12h-12zM78 305h12v12H78zM90 317h12v12H90zM90 293h12v12H90zM102 305h12v12h-12z"
    />
    <circle
      cx={390}
      cy={103}
      r={14}
      style={{
        fill: "#2d2d2d",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
    <circle
      cx={303}
      cy={63.5}
      r={14}
      style={{
        fill: "#2d2d2d",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
    <circle
      cx={189}
      cy={63.5}
      r={14}
      style={{
        fill: "#2d2d2d",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
    <circle
      cx={122}
      cy={96}
      r={14}
      style={{
        fill: "#2d2d2d",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
    <circle
      cx={203}
      cy={158}
      r={14}
      style={{
        fill: "#2d2d2d",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
    <circle
      cx={298}
      cy={251.5}
      r={14}
      style={{
        fill: "#2d2d2d",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
    <circle
      cx={263}
      cy={315}
      r={14}
      style={{
        fill: "#2d2d2d",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
    <circle
      cx={365}
      cy={333}
      r={14}
      style={{
        fill: "#2d2d2d",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
    <circle
      cx={263}
      cy={354}
      r={14}
      style={{
        fill: "#2d2d2d",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
    <circle
      cx={263}
      cy={441.5}
      r={14}
      style={{
        fill: "#2d2d2d",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
    <circle
      cx={365}
      cy={441.5}
      r={14}
      style={{
        fill: "#2d2d2d",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
    <circle
      cx={169}
      cy={327}
      r={14}
      style={{
        fill: "#2d2d2d",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
    <circle
      cx={142}
      cy={259}
      r={14}
      style={{
        fill: "#2d2d2d",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
    <circle
      cx={66.5}
      cy={243}
      r={14}
      style={{
        fill: "#2d2d2d",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
    <circle
      cx={66.5}
      cy={164}
      r={14}
      style={{
        fill: "#2d2d2d",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
    <circle
      cx={446}
      cy={172}
      r={14}
      style={{
        fill: "#2d2d2d",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
    <circle
      cx={446}
      cy={266}
      r={14}
      style={{
        fill: "#2d2d2d",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
    <circle
      cx={322}
      cy={164}
      r={14}
      style={{
        fill: "#2d2d2d",
        stroke: "#f8f8f8",
        strokeWidth: 8,
      }}
    />
  </svg>
);

export default Crifferent;
